export default __webpack_public_path__ + "81385b2990cf158a4db367fb0d81e115.ttf";